import React, { useEffect, useState } from 'react';

const data = [
  { stt: 1, noiDung: 'Homestay tối thứ sáu', ghiChu:'Thiên nhiên an toàn khi chúng ta quan sát, xuất phát sớm để có một giấc ngủ đầy đủ trước khi leo là chuẩn bị tốt nhất trước khi leo'},
  { stt: 2, noiDung: 'Ăn sáng thứ bảy', ghiChu:'Tụt đường huyết xảy ra khi bạn hăng hái leo quá nhanh vào buổi sáng, bữa sáng với tinh bột như cơm, đầy đủ thịt và trứng giúp bạn phòng tránh nguy cơ thiếu đường.'  },
  { stt: 3, noiDung: 'Nước bù khoáng', ghiChu:'Leo núi ra mồ hôi, bạn cần nhất là bù khoáng bằng Ozeron hoặc C sủi' },
  { stt: 4, noiDung: 'Đồ dùng y tế', ghiChu:'Một vết thương nhỏ là đủ nhiễm trùng, đã chuẩn bị: hạ sốt, còn Pavoli, thuốc sát trùng, thuốc đau bụng' },
  { stt: 5, noiDung: 'Bánh ngọt, So Co La', ghiChu:'Tụt đường huyết xảy ra khi tốc độ bạn di chuyển quá nhanh, tuần hoàn máu không thể đáp ứng. Bổ sung đường vào buổi chiều giúp bạn phòng tránh tụt đường huyết' },
  { stt: 6, noiDung: 'Porter bản địa', ghiChu:'Lưng không đeo hành lý nặng nề giúp bạn linh hoạt trong mọi tình huống. Số lượng porter ở đây dự tính cho trường hợp họ vác cả balo cá nhân của đoàn, bạn chỉ cần đeo ba lo nhỏ chứa nước, bánh kẹo' },
  { stt: 7, noiDung: 'Đồ ăn leo núi, áo mưa, găng tay, nước',  ghiChu:'Porter sẽ chuẩn bị thực phẩm, nấu ăn cho bạn trong suốt quá trình leo. Các món ăn thường sẽ được nấu theo nguyên liệu bản địa'},
  { stt: 8, noiDung: 'Ăn tối chủ nhật', ghiChu:'Bữa tiệc nho nhỏ chúc mừng chuyến đi'  },
  { stt: 9, noiDung: 'Kỷ niệm chương', ghiChu:'Kỷ niệm hoàn thành chuyến đi'  }
];

const Timeline = ({ groupSize, days }) => {
  const [tongDuTinh, setTongDuTinh] = useState(0);
  useEffect(() => {
    let total = 0;
    data.forEach((item) => {
      if (item.stt == 6) {
        total += item.soTienChi * (Math.ceil((groupSize ) / 2) * days);
      } else if (item.stt == 7) {
        total += item.soTienChi * ( groupSize * days);
      }else {
        total += item.soTienChi * groupSize;
      }
    });
    setTongDuTinh(total);
  }, [groupSize, days]);

  return (
    <div className="min-h-screen flex justify-center items-center p-1 sm:p-1">
      <div className="bg-white shadow-md rounded-lg w-full max-w-4xl overflow-hidden">
        
        {/* Table wrapper for responsiveness */}
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto text-sm">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-1 border text-left">Nội dung</th>
                <th className="p-1 border text-left">Diễn giải</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => {
                let soLuong = groupSize;
                if (item.stt == 6) {
                  soLuong = Math.ceil((groupSize) / 2) * days;
                } else if (item.stt == 7) {
                  soLuong = groupSize * days;
                }

                return (
                  <tr key={item.stt} className="bg-white even:bg-gray-50">
                    <td className="p-1 border text-sm">{item.noiDung}</td>
                    <td className="p-1 border text-sm">{item.ghiChu}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
